import styles from './Decision.module.css';
import FormalOfferCard from './FormalOfferCard';
import offeredAnimation from '../../assets/offeredAnimation.gif';
import { TGetFormalOffersResponse } from '../../types';
import { ACCOUNT_PAGES_URL } from '../../urls';
import { Button } from '../Button/Button';

type TProps = {
  formalOffersData: TGetFormalOffersResponse['data'];
};

const OfferedDecision = ({ formalOffersData }: TProps) => {
  return (
    <div className={styles.container}>
      <h1 className={styles.heading}>You’re ready to draw down your offer</h1>
      <h2 className={styles.subHeading}>
        Head to iwoca to review your offer and take your funds.
      </h2>
      <div className={styles.gifContainer}>
        <img data-testid="offered-animation" src={offeredAnimation} alt="" />
      </div>
      <FormalOfferCard {...formalOffersData?.formal_offers[0]} />
      <div className={styles.buttonContainer}>
        <Button href={ACCOUNT_PAGES_URL} size="large">
          Review your offer
        </Button>
      </div>
    </div>
  );
};

export default OfferedDecision;
